import constants from "../constants";
import outgoingDocService from "../services/outgoingDocService";
import incomingDocService from "../services/incomingDocService";
import tkTaskService from "../services/tkTaskService";
import menuConfigService from "../services/menuConfigService";
import errorMessageFilter from "../filters/errorMessageFilter";
import newsService from "../services/newsService";
import discussService from "../services/discussService";
import notifiService from "../services/notifiService";
import documentService from "../services/documentService";

export default {
  name: "NotifyCard",
  methods: {
    routeToVbIncomingDocDetail(docId, vbIncomingDocUserView, userDeptRole) {
      let userDeptRoleId = userDeptRole.id;
      let delegateInfoId = vbIncomingDocUserView
        ? vbIncomingDocUserView.delegateInfoId
        : null;
      if (!vbIncomingDocUserView) {
        incomingDocService.findById(docId)
          .then(response => {
            let doc = response.data;
            if (doc.status == constants.INCOMING_DOC_STATUS.DANG_XU_LY) {
              this.$router.replace({
                name: "vbDenDaTiepNhanDetail",
                params: { id: docId, userDeptRoleId: userDeptRoleId }
              });
            } else {
              if (!doc.forwardIncomingDocId) {
                //luu tam o day, de sang man hinh cho tiep nhan thi bat popup;
                localStorage.setItem(
                  constants.STORAGE_KEY.CHO_TIEP_NHAN_DOC_ID,
                  docId
                );
                this.$router.replace({
                  name: "vbChoTiepNhan",
                  params: { id: docId, userDeptRoleId: userDeptRoleId }
                });
              } else {
                this.$router.replace({
                  name: "vbChoTiepNhanDetailEditable",
                  params: { id: docId, userDeptRoleId: userDeptRoleId }
                });
              }
            }
          }).catch(() => {
            this.$message({
              message: "Văn bản đến đã thu hồi hoặc không tồn tại",
              type: "warning"
            })
          })
      } else if (delegateInfoId) {
        this.$router.replace({
          name: "vbDenUyQuyenDetail",
          params: {
            id: vbIncomingDocUserView.vbIncomingDocUserViewKey.id,
            userDeptRoleId: userDeptRoleId
          },
          query: {
            vbDocProcessId: vbIncomingDocUserView.vbDocUserVbDocProcessId
          }
        });
      } else if (
        vbIncomingDocUserView.vbDocUserStatus ===
        constants.DOC_USER_STATUS.CHO_XU_LY
      ) {
        this.$router.replace({
          name: "vbDenChoXuLyDetail",
          params: {
            id: vbIncomingDocUserView.vbIncomingDocUserViewKey.id,
            userDeptRoleId: userDeptRoleId
          },
          query: {
            vbDocProcessId: vbIncomingDocUserView.vbDocUserVbDocProcessId
          }
        });
      } else {
        this.$router.replace({
          name: "vbDenDaXuLyDetail",
          params: {
            id: vbIncomingDocUserView.vbIncomingDocUserViewKey.id,
            userDeptRoleId: userDeptRoleId
          },
          query: {
            vbDocProcessId: vbIncomingDocUserView.vbDocUserVbDocProcessId
          }
        });
      }
    },

    routeToVbOutgoingDocDetail(docId, vbOutgoingDocUserView, userDeptRole) {
      let userDeptRoleId = userDeptRole.id;
      if (!vbOutgoingDocUserView) {
        outgoingDocService
          .findById(docId)
          .then(res => {
            this.$router.replace({
              name: "vbChoBanHanhDetail",
              params: { id: docId, userDeptRoleId: userDeptRoleId }
            });
          })
          .catch(() =>
            this.$message({
              message: "Văn bản đi đã thu hồi hoặc không tồn tại",
              type: "warning"
            })
          );
      } else {
        let relationType = vbOutgoingDocUserView.relationType;
        let filterStatus;
        switch (relationType) {
          case constants.VB_DOC_USER.RELATION_TYPE.NGUOI_UY_QUYEN:
            filterStatus = constants.DU_THAO_PAGE.FILTER.UY_QUYEN;
            break;
          case constants.VB_DOC_USER.RELATION_TYPE.NGUOI_PHOI_HOP:
            filterStatus = constants.DU_THAO_PAGE.FILTER.PHOI_HOP;
            break;
          default:
            filterStatus = null;
            break;
        }

        if (
          vbOutgoingDocUserView.status ===
          constants.OUTGOING_DOC_STATUS.DABANHANH
        ) {
          if (userDeptRole.roleCode === "vanthu") {
            this.$router.replace({
              name: "vbDaBanHanhDetail",
              params: {
                id: vbOutgoingDocUserView.vbOutgoingDocUserViewKey.id,
                userDeptRoleId: userDeptRoleId
              }
            });
          } else {
            this.$router.replace({
              name: "vbDaPhatHanhNewDetail",
              params: {
                id: vbOutgoingDocUserView.vbOutgoingDocUserViewKey.id,
                userDeptRoleId: userDeptRoleId
              },
              query: {
                vbDocProcessId: vbOutgoingDocUserView.vbDocUserVbDocProcessId,
                filterStatus: filterStatus
              }
            });
          }
        } else if (
          vbOutgoingDocUserView.status ===
          constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH
        ) {
          if (userDeptRole.roleCode === "vanthu") {
            this.$router.replace({
              name: "vbChoBanHanhDetail",
              params: {
                id: vbOutgoingDocUserView.vbOutgoingDocUserViewKey.id,
                userDeptRoleId: userDeptRoleId
              }
            });
          } else {
            this.$router.replace({
              name: "vbDuThaoNewDetail",
              params: {
                id: vbOutgoingDocUserView.vbOutgoingDocUserViewKey.id,
                userDeptRoleId: userDeptRoleId
              },
              query: {
                vbDocProcessId: vbOutgoingDocUserView.vbDocUserVbDocProcessId,
                filterStatus:
                  filterStatus ||
                  (vbOutgoingDocUserView.vbDocUserStatus ===
                    constants.DOC_USER_STATUS.DA_XU_LY
                    ? constants.DU_THAO_PAGE.FILTER.DA_XU_LY
                    : constants.DU_THAO_PAGE.FILTER.CHO_XU_LY)
              }
            });
          }
        } else if (
          (vbOutgoingDocUserView.status ===
            constants.OUTGOING_DOC_STATUS.TU_CHOI ||
            vbOutgoingDocUserView.status ===
            constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH) &&
          vbOutgoingDocUserView.editorId === vbOutgoingDocUserView.userId
        ) {
          this.$router.replace({
            name: "vbDuThaoNewEdit",
            params: {
              id: vbOutgoingDocUserView.vbOutgoingDocUserViewKey.id,
              userDeptRoleId: userDeptRoleId
            }
          });
        } else {
          this.$router.replace({
            name: "vbDuThaoNewDetail",
            params: {
              id: vbOutgoingDocUserView.vbOutgoingDocUserViewKey.id,
              userDeptRoleId: userDeptRoleId
            },
            query: {
              vbDocProcessId: vbOutgoingDocUserView.vbDocUserVbDocProcessId,
              filterStatus:
                filterStatus ||
                (vbOutgoingDocUserView.vbDocUserStatus ===
                  constants.DOC_USER_STATUS.DA_XU_LY
                  ? constants.DU_THAO_PAGE.FILTER.DA_XU_LY
                  : constants.DU_THAO_PAGE.FILTER.CHO_XU_LY)
            }
          });
        }
      }
    },

    routeToTaskDetail(taskId, userDeptRoleId) {
      tkTaskService
        .findByIdAndUserDeptRoleId(taskId, userDeptRoleId)
        .then(response => {
          let tkTask = response.data;
          if (!tkTask) {
            this.$message({
              message: errorMessageFilter({ errorCode: "tkTask.notFound" }),
              type: "warning"
            });
            return null;
          }
          Promise.all([
            menuConfigService.isEnableMenu(
              userDeptRoleId,
              constants.MENU_LIST.CONGVIEC_DUOCGIAO
            ),
            menuConfigService.isEnableMenu(
              userDeptRoleId,
              constants.MENU_LIST.CONGVIEC_GIAO
            ),
            menuConfigService.isEnableMenu(
              userDeptRoleId,
              constants.MENU_LIST.CONGVIEC_LIENQUAN
            )
          ]).then(results => {
            let isDuocGiaoAccessible = results[0];
            let isGiaoViecAccessible = results[1];
            let isCvLienQuanAccessible = results[2];
            if (
              tkTask.receiverUserDeptRoleId === userDeptRoleId &&
              isDuocGiaoAccessible
            ) {
              this.$router.replace({
                name: "detail-job",
                params: { id: taskId, userDeptRoleId: userDeptRoleId },
                query: { viewType: constants.JOB_INDEX_PAGE.VIEW_TYPE.RECEIVER }
              });
            } else if (
              (tkTask.assignerUserDeptRoleId === userDeptRoleId ||
                tkTask.delegatorId === userDeptRoleId) &&
              isGiaoViecAccessible
            ) {
              this.$router.replace({
                name: "detail-job-assigned",
                params: { id: taskId, userDeptRoleId: userDeptRoleId },
                query: { viewType: constants.JOB_INDEX_PAGE.VIEW_TYPE.ASSIGNER, taskStatusFilter: "all", }
              });
            } else if (isCvLienQuanAccessible) {
              this.$router.replace({
                name: "detail-job-coordinate",
                params: { id: taskId, userDeptRoleId: userDeptRoleId },
                query: {
                  viewType: constants.JOB_INDEX_PAGE.VIEW_TYPE.COORDINATOR
                }
              });
            }
          });
        }).catch(error => {
          if (error.response && error.response.data) {
            let status = error.response.data.status;
            switch (status) {
              case constants.HTTP_STATUS.FORBIDDEN:
                this.message(
                  "Thông báo",
                  "Bạn không còn quyền truy cập!",
                  "warning"
                );
                break;
              default:
                this.message(
                  "Thông báo",
                  "Tài nguyên không còn tồn tại!",
                  "warning"
                );
            }
          };
        });
    },

    routeToNotiDetail(notiId, detailNoti) {
      notifiService
        .findById(notiId)
        .then(res => {
          this.$router.replace({
            name: "myNotifiDetail",
            params: { id: notiId, userDeptRoleId: detailNoti.toUserDeptRoleId },
          });
        })
        .catch(() =>
          this.$message({
            message: "Thông báo đã bị xóa",
            type: "warning"
          })
        );
    },

    routeToNewsDetail(newsId, detailDews) {
      newsService
        .findById(newsId)
        .then(res => {
          this.$router.replace({
            name: "news",
            params: { currentNews: res.data, userDeptRoleId: detailDews.toUserDeptRoleId },
            // query: { currentNews: res.data }
          });
        })
        .catch(() =>
          this.$message({
            message: "Tin tức đã bị xóa",
            type: "warning"
          })
        );
    },

    routeToDiscussDetail(discussId, discuss) {
      discussService
        .findById(discussId)
        .then(res => {
          this.$router.replace({
            name: "discussionDetail",
            params: { id: discussId, userDeptRoleId: discuss.toUserDeptRoleId },
          });
        })
        .catch(() =>
          this.$message({
            message: "Thảo luận đã bị xóa",
            type: "warning"
          })
        );
    },

    routeToDocumentDetail(documentId, documnent) {
      documentService
        .findById(documentId)
        .then(res => {
          this.$router.replace({
            name: "DocumentDetail",
            params: { id: documentId, userDeptRoleId: documnent.toUserDeptRoleId },
          });
        })
        .catch(() =>
          this.$message({
            message: "Tài liệu đã bị xóa",
            type: "warning"
          })
        );
    },

    routeToHanhChinhPHDetail(hanhChinhId, hanhchinh) {
      this.$router.replace({
        name: "adminstration-detail",
        params: { id: hanhChinhId, userDeptRoleId: hanhchinh.toUserDeptRoleId },
      });
    },

    routeToHanhChinhLTDetail(hanhChinhId, hanhchinh) {
      this.$router.replace({
        name: "adminstration-regiscalendarweek-detail",
        params: { id: hanhChinhId, userDeptRoleId: hanhchinh.toUserDeptRoleId },
      });
    },

    routeToHanhChinhDXDetail(hanhChinhId, hanhchinh) {
      this.$router.replace({
        name: "adminstration-getCarDetail",
        params: { id: hanhChinhId, userDeptRoleId: hanhchinh.toUserDeptRoleId },
      });
    },
  }
};



// WEBPACK FOOTER //
// ./src/mixins/commonRouteVbMixin.js